import React from 'react'
import classNames from 'classnames'
import { Avatar } from 'antd'

import styles from './styles.module.scss'

import type { LntAvatarProps } from './types'

export const LntAvatar: React.FC<LntAvatarProps> = props => {
  const { className: outerClassName, children, ...restProps } = props

  const className = classNames(styles.lntAvatar, outerClassName)

  return (
    <Avatar
      { ...restProps }
      className={ className }
    >
      { children }
    </Avatar>
  )
}
